/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MailParamsDirectDebitReturnPaymentReminderTemplateData } from '../../models/mail-params-direct-debit-return-payment-reminder-template-data';
import { ResponseObject } from '../../models/response-object';

export interface SendDirectDebitReturnPaymentReminderTollMail$Params {
      body: MailParamsDirectDebitReturnPaymentReminderTemplateData
}

export function sendDirectDebitReturnPaymentReminderTollMail(http: HttpClient, rootUrl: string, params: SendDirectDebitReturnPaymentReminderTollMail$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponseObject>> {
  const rb = new RequestBuilder(rootUrl, sendDirectDebitReturnPaymentReminderTollMail.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ResponseObject>;
    })
  );
}

sendDirectDebitReturnPaymentReminderTollMail.PATH = '/sendMail/direct-debit-return-payment-reminder-toll';
